export enum ReferralSourceEnum {
  INTERNAL_REFERRAL = 'Internal Referral',
  CLIENT_SELF_REFERRAL = 'Client Self Referral',
  DIRECT_REFERRAL = 'Direct Referral',
  PSL_REFERRAL = 'PSL Referral',
  VA_REFERRAL = 'Salesforce VA Referral',
  DOC_ASAP_REFERRAL = 'DocASAP Appointment Request',
  EBCG_REFERRAL = 'Evernorth Behavioral Care Group Embrace',
  HEADSPACE_REFERRAL = 'Headspace',
  ZOCDOC_REFERRAL = 'Zocdoc Appointment Request',
  HCP_REFERRAL = 'Salesforce HCP Referral',
  SIMILAR_PROVIDERS_REFERRAL = 'Similar Providers Referral',
  CONFIGURABLE_CLIENT_REFERRAL = 'Configurable Client Referral',
  CONCIERGE_AI_REFERRAL = 'Concierge AI Intake Referral'
}

export const PARTNER_REFERRAL_SOURCES = [
  ReferralSourceEnum.DOC_ASAP_REFERRAL,
  ReferralSourceEnum.EBCG_REFERRAL,
  ReferralSourceEnum.HEADSPACE_REFERRAL,
  ReferralSourceEnum.ZOCDOC_REFERRAL
];
